import { render } from "./settingIcon.vue?vue&type=template&id=4bfa28e6"
const script = {}

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__